import styled, { css } from 'styled-components';
import { Input } from 'antd';
import { colorGroup } from '../common';

export const borderGreyCss = css`
	border: 1px solid #dfe1e6;
`;
export const borderBlueCss = css`
	border-color: ${colorGroup.primaryColor};
`;
export const inputHoverBgCss = css`
	background: ${colorGroup.bgPage};
`;
export const inputBgCss = css`
	background: #fff;
`;

export const inputCss = css`
	width: 100%;
	border-radius: 2px;
	${borderGreyCss}
	${inputBgCss}
	box-shadow: none;
	:hover {
		box-shadow: none;
		${borderGreyCss}
		${inputHoverBgCss}
	}
	:focus {
		box-shadow: none;
		${borderBlueCss}
		${inputBgCss}
	}
`;

export const CustomInput = styled(Input)`
	${inputCss}
`;

export const CustomInputPassword = styled(Input.Password)`
	${inputCss}
`;

export const CustomInputSearch = styled(Input.Search)`
	& .ant-input-wrapper.ant-input-group {
		${borderGreyCss};
		${inputBgCss};
		border-radius: 4px;

		& .ant-input {
			${inputBgCss}
			border: none;

			:focus {
				box-shadow: none;
			}
		}

		& .ant-input-group-addon {
			& .ant-btn {
				${inputBgCss}
				border: none;
				box-shadow: none;
			}
		}
	}
`;

export const inputWithClearCss = css`
	width: 100%;
	border-radius: 2px;
	${borderGreyCss}
	${inputBgCss}
	box-shadow: none;

	&&:hover {
		${borderGreyCss}
		${inputHoverBgCss}
		box-shadow: none;

		.ant-input {
			${inputHoverBgCss}
		}
	}

	:focus {
		box-shadow: none;
		${borderBlueCss}
	}

	& .ant-input {
		background: ${colorGroup.bgBtn};
	}
`;

export const CustomInputWithClear = styled(Input)`
	${inputWithClearCss}
`;
